'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_ShownEvent$() {
}
export { $c_Ldev_cheleb_scalamigen_ShownEvent$ as $c_Ldev_cheleb_scalamigen_ShownEvent$ };
$p = $c_Ldev_cheleb_scalamigen_ShownEvent$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_ShownEvent$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_ShownEvent$() {
}
export { $h_Ldev_cheleb_scalamigen_ShownEvent$ as $h_Ldev_cheleb_scalamigen_ShownEvent$ };
$h_Ldev_cheleb_scalamigen_ShownEvent$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return (-788702167);
});
$p.b = (function() {
  return "ShownEvent";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "ShownEvent";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
});
$p.y = (function(p) {
  return this;
});
var $d_Ldev_cheleb_scalamigen_ShownEvent$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_ShownEvent$, "dev.cheleb.scalamigen.ShownEvent$", ({
  jg: 1,
  bN: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ldev_cheleb_scalamigen_ShownEvent$ as $d_Ldev_cheleb_scalamigen_ShownEvent$ };
var $n_Ldev_cheleb_scalamigen_ShownEvent$;
function $m_Ldev_cheleb_scalamigen_ShownEvent$() {
  if ((!$n_Ldev_cheleb_scalamigen_ShownEvent$)) {
    $n_Ldev_cheleb_scalamigen_ShownEvent$ = new $c_Ldev_cheleb_scalamigen_ShownEvent$();
  }
  return $n_Ldev_cheleb_scalamigen_ShownEvent$;
}
export { $m_Ldev_cheleb_scalamigen_ShownEvent$ as $m_Ldev_cheleb_scalamigen_ShownEvent$ };
